import axios from "axios"

export function AddressAPI() {
  function isDeliveryAddressValid(address) {
    const csrfTokenTag = document.querySelector('meta[name=csrf-token]');
    const csrfToken = csrfTokenTag ? csrfTokenTag.content : '';
    let instance = axios.create({ headers: { 'X-CSRF-Token': csrfToken } })

    return new Promise((resolve, reject) => {
      instance({
        method: "post",
        url: "/deliverable_addresses",
        data: addressAttributes(address)
      })
      .then(({ data }) => {
        if(!data.valid_delivery_address || data.in_exclusion_area) {
          reject(data)
        } else {
          resolve(data)
        }
      }).catch(() => { reject(false) })
    })
  }

  function saveAddress(address) {
    const csrfTokenTag = document.querySelector('meta[name=csrf-token]');
    const csrfToken = csrfTokenTag ? csrfTokenTag.content : '';
    let data = addressAttributes(address)
    data["save_as_default"] = true

    let instance = axios.create({ headers: {  'X-CSRF-Token': csrfToken } })
    instance({
      url: "/shipping_addresses",
      method: "post",
      data: data
    }).then(() => {
      Turbolinks.visit(location.toString())
    })
  }

  function addressAttributes(address) {
   return {
      "shipping_address": {
        "firstname": address.firstname,
        "lastname": address.lastname,
        "address1": address.address,
        "city": address.city,
        "zipcode": address.zipcode,
        "phone": address.phone,
        "country_code": address.country_code,
        "longitude": address.longitude,
        "latitude": address.latitude

      },
      "state": address.state
    }
  }

  function missingStreetNumberMessage() {
    $("[data-invalid-address-wrapper]")
    .popover(
      {
        title: "Missing Street Number",
        content: "Psst! We need your street number in order to validate your address. Please try again",
        trigger: "manual",
        template: '<div class="popover is-danger" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
      }
    )
  }
 
  function showInvalidAddressMsg(exclusionArea, deliveryAddressTarget) {
    let invalidAddressTitle = "🚚 We’re not in your area…yet!"
  
    deliveryAddressTarget.classList.remove("validating")
    $("[data-target='address-search.invalidAddress']").popover("dispose")

    if(exclusionArea) {
      invalidAddressTitle = "This is an exclusion area"

      $("[data-invalid-address-wrapper]")
      .popover(
        { 
          title: invalidAddressTitle,
          content: "<div>We’re unable to deliver to your address because it appears to be a public park, public school, publicly owned or leased land.</div>",
          trigger: "manual",
          template: '<div class="popover is-danger delivery-zone" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
        }
      )
    }

    $("[data-invalid-address-wrapper]")
    .popover(
      { 
        title: invalidAddressTitle,
        content: function() {
          var clone= $($(this).data('popover-content')).clone(true).removeClass('popover-hide')
          return clone;
        },
        trigger: "manual",
        template: '<div class="popover is-danger delivery-zone" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
      }
    )

    $("[data-target='address-search.invalidAddress']").popover("show")
  }

  function setCookies(address, zipcode, place, state, coordinates) {
    document.cookie = `zipcode=${zipcode};Path=/`
    document.cookie = `city=${place};Path=/`
    document.cookie = `state=${state};Path=/`
    document.cookie = `temp_delivery_address=${address};Path=/`
    document.cookie = "isValid=true;Path=/"
    document.cookie = `longitude=${coordinates[0]};Path=/`
    document.cookie = `latitude=${coordinates[1]};Path=/`
  }

  function expireCookies() {
    document.cookie = "temp_delivery_address=;expires=Thu, 01 Jan 1970 00:00:01 GMT"
    document.cookie = "isValid=;expires=Thu, 01 Jan 1970 00:00:01 GMT"
    document.cookie = "city=;expires=Thu, 01 Jan 1970 00:00:01 GMT"
    document.cookie = "zipcode=;expires=Thu, 01 Jan 1970 00:00:01 GMT"
    document.cookie = "state=;expires=Thu, 01 Jan 1970 00:00:01 GMT"
    document.cookie = "place=;expires=Thu, 01 Jan 1970 00:00:01 GMT"
    document.cookie = "longitude=;expires=Thu, 01 Jan 1970 00:00:01 GMT"
    document.cookie = "latitude=;expires=Thu, 01 Jan 1970 00:00:01 GMT"
  }

  function saveInvalidShippingAddress(user_address, invalid_address) {
    const csrfTokenTag = document.querySelector('meta[name=csrf-token]');
    const csrfToken = csrfTokenTag ? csrfTokenTag.content : '';

    let instance = axios.create({ headers: {  'X-CSRF-Token': csrfToken } })
    instance({
      url: "/invalid_shipping_addresses",
      method: "post",
      data: { user_address: user_address, invalid_address: invalid_address }
    })
  }

  function isCompleteAddress(address) {
    return address.street_number && address.zipcode && address.city
  }

  function isMissingStreetNumber(address) {
    return !address.street_number && address.address && address.city
  }

  return {
    expireCookies,
    isDeliveryAddressValid,
    saveAddress,
    setCookies,
    showInvalidAddressMsg,
    saveInvalidShippingAddress,
    isCompleteAddress,
    isMissingStreetNumber,
    missingStreetNumberMessage
  }
}
